import clsx from 'clsx';

type Props = {
  emoji: string | null;
  // 'sm' targets ~220px donuts (inner ⌀ ≈ 132px); 'md' targets ~320px donuts.
  size?: 'sm' | 'md';
};

// Absolutely-positioned glyph rendered at the center of a donut's hole.
// The parent chart container must be `position: relative`. Pointer events
// pass through so slice hover stays uninterrupted.
export function DonutCenterEmoji({ emoji, size = 'sm' }: Props) {
  return (
    <div
      aria-hidden
      className="pointer-events-none absolute inset-0 flex items-center justify-center"
      style={{
        opacity: emoji ? 1 : 0,
        transition: 'opacity 0.18s ease',
      }}
    >
      <span
        className={clsx(
          'select-none leading-none',
          size === 'md' ? 'text-5xl' : 'text-4xl'
        )}
      >
        {emoji ?? ''}
      </span>
    </div>
  );
}
